
import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';

import styles from '../../styles.js';

const Caret = ({ className }) => {
    return (
        <div className={css(styles.iconWrapper, styles[className])}>
            <svg
                viewBox="0 0 18 18"
                role="presentation"
                aria-hidden="true"
                focusable="false"
                style={{
                    display: 'block',
                    fill: 'currentcolor',
                    height: '10px',
                    width: '10px'
                }}
            >
                <path
                    fillRule="evenodd"
                    d="M16.291 4.295a1 1 0 1 1 1.414 1.415l-8 7.995a1 1 0 0 1-1.414 0l-8-7.995a1 1 0 1 1 1.414-1.415l7.293 7.29 7.293-7.29z"
                />
            </svg>
        </div>
    );
};

Caret.propTypes = {
    className: PropTypes.string.isRequired
};

export default Caret;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/PanelFilterGroupCollection/CaretWrapper/Caret/Caret.jsx